import { Injectable } from '@angular/core';
import { AbstractControl, ValidatorFn } from '@angular/forms';

@Injectable()
export class PasswordValidators {

    validateNewPassword(minLength: number): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } => {

            let newPassword = control.value;

            if ((newPassword == null) || (newPassword == ''))
                return null;

            if (newPassword.length < minLength)
                return { 'tooShort': { value: minLength } };

            // Aggiungere altre verifiche?

            return null;
        }
    }

    validatePasswords(): ValidatorFn {
        return (group: AbstractControl): { [key: string]: any } => {

            let oldPassword = group.get('oldPassword').value;
            let newPassword = group.get('newPassword').value;
            let newPasswordAgain = group.get('newPasswordAgain').value;

            if ((oldPassword != null) && (oldPassword != '')) {

                if ((newPassword == null) || (newPassword == ''))
                    return null;

                if (oldPassword == newPassword)
                    return { 'equalPassword': { value: newPassword } };
            }

            if ((newPassword == null) || (newPassword == '')
                || (newPasswordAgain == null) || (newPasswordAgain == ''))
                return null;

            if (newPassword != newPasswordAgain)
                return { 'notMatching': { value: newPasswordAgain } };

            return null;
        }
    }

    validatePasswordStrength(): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } => {

            let newPassword = control.value;


            let validated = true;

            //obbligatorio numero
            if (!/\d/.test(newPassword)) {
                validated = false;
            }

            //obbligatorio minuscola
            if (!/[a-z]/.test(newPassword)) {
                validated = false;
            }

            //obbligatorio maiuscola
            if (!/[A-Z]/.test(newPassword)) {
                validated = false;
            }

            //obbligatorio simbolo
            if (!/[!()\-+.?\[\]_$]/.test(newPassword)) {
                validated = false;
            }

            //permessi
            if (/[^0-9a-zA-Z!()\-+.?\[\]_$]/.test(newPassword)) {
                validated = false;
            }
            if (validated) {
                return null;
            } else {
                return { 'noStrength': { value: newPassword } };
            }

        }
    }
}


// WEBPACK FOOTER //
// ./src/app/exa/_validators/password.validators.ts